import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as actionTypes from '../../redux/actionTypes';
import Banner from './Banner';
import analyticsService from '../../shared/analytics/analytics-service';


function NotificationBanner(props) {
  const [driverBanner, setDriverBanner] = useState(null);
  const [systemBanners, setSystemBanners] = useState([]);
  const [dismissibleBanners, setDismissibleBanners] = useState([]);


  useEffect(() => {
    if (props.alerts.length) {
      var systemBanners = props.alerts.filter((alert) => alert.priority == 1 && !alert.isRead && !alert.alertTypeCode.toLowerCase().includes("dbds")) //filter out driverbanner with this code.
      var sortedSystemBanners = getSortedBanners(systemBanners);
      setSystemBanners(sortedSystemBanners);
      if(sortedSystemBanners && sortedSystemBanners.length){
        analyticsService.analyticsProcessEvent(
          {
            "event": "banner view",
            "context": {
                "event_action": "banner view",
                "banner_topic": "system generated",
                "banner_count" : sortedSystemBanners && sortedSystemBanners.length
            }
          });
      }
      var allDismissibleBanners = props.alerts.filter((alert) => alert.priority == 2 && !alert.isRead)
      setDriverBanner(allDismissibleBanners.find((alert) => alert.alertTypeCode.toLowerCase().includes("db")) || null);
      var dismissibleBanners = allDismissibleBanners.filter((alert) => !alert.alertTypeCode.toLowerCase().includes("db"))
      var sortedDismissibleBanners = getSortedBanners(dismissibleBanners);
      setDismissibleBanners(sortedDismissibleBanners);
      if(sortedDismissibleBanners && sortedDismissibleBanners.length){
        analyticsService.analyticsProcessEvent(
          {
            "event": "banner view",
            "context": {
                "event_action": "banner view",
                "banner_topic": "dismissible",
                "banner_count" : sortedDismissibleBanners && sortedDismissibleBanners.length
            }
          });
      }
    }
  }, [props.alerts]);

  const close = (alert) => {
    let unclosedAlerts = dismissibleBanners.filter(a => a.alertId !== alert.alertId);
    setDismissibleBanners(unclosedAlerts);
    props.readBanner(alert)
  }

  const getSortedBanners = (banners) => {
      var sortedbanners =  banners.sort((banner1, banner2) => {
          return new Date(banner2.createdDate) - new Date(banner1.createdDate);
      });
      return sortedbanners
  }

  return (
    (driverBanner || systemBanners.length > 0 || dismissibleBanners.length > 0) &&
      <div className="notification-banners">
      {
        driverBanner &&
          <Banner banner={driverBanner} history={props.history} />
      }
      {
        systemBanners.length > 0 && systemBanners.map((banner, index) => (
          <Banner banner={banner} key={index} />
        ))
      }
      {
        dismissibleBanners.length > 0 && dismissibleBanners.map((banner, index) => (
          <Banner banner={banner} isDismissible={true} close={(e) => close(e)} key={index} />
        ))
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    alerts: state.alerts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    readBanner(alert) {
      dispatch({ type: actionTypes.READ_BANNER_ALERT, data: alert });
  },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBanner);
